import styled, { css } from 'styled-components';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import ColorConstants from '@shared/constants/ColorConstants';

export const MemberBox = styled.div`
    align-items: center;
    color: ${ColorConstants.white};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    font-size: 15px;

    @media ${MobileScreen}{
        font-size: 14px;
    }
`;

export const WhiteBox = styled.img`
    border-radius: 3px;
    height: 18px;
    margin-right: 15px;
    width: 18px;
    @media ${MobileScreen} {
        height: 14px;
        width: 14px;
    }
`;

export const Span = styled.span`
    ${({ isDesktop }) => isDesktop && css`
            margin-left: 4px;
            font-size: 14px;
            font-family: 'Helvetica';
            color: ${ColorConstants['black-50%']};
        `};
`;
